<script setup>
defineProps({
  minutes: {
    type: Number,
    required: true,
  },
});

const calculateDisplayTime = (totalMinutes) => {
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  let display = '';

  if (hours > 0) {
    display += `${hours}hr${hours > 1 ? 's' : ''} `;
  }
  if (minutes > 0 || hours === 0) {
    display += `${minutes}min${minutes !== 1 ? 's' : ''}`;
  }

  return display.trim();
}
</script>

<template>
  <div class="tw-flex tw-items-center tw-gap-2 tw-text-grey tw-text-sm tw-whitespace-nowrap">
    <svg-vue
      icon="icons/stopwatch"
      class="tw-w-6 tw-h-6 tw-flex-0"
    />
    <span>
      {{ calculateDisplayTime(minutes) }}
    </span>
  </div>
</template>

